import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const MenuCreate = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 48 48">
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="24" r="24" fill="#F5E4E7"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M14 12C12.8954 12 12 12.8954 12 14V34C12 35.1046 12.8954 36 14 36H34C35.1046 36 36 35.1046 36 34V14C36 12.8954 35.1046 12 34 12H14ZM23 17C23 16.4477 23.4477 16 24 16C24.5523 16 25 16.4477 25 17V23H31C31.5523 23 32 23.4477 32 24C32 24.5523 31.5523 25 31 25H25V31C25 31.5523 24.5523 32 24 32C23.4477 32 23 31.5523 23 31V25H17C16.4477 25 16 24.5523 16 24C16 23.4477 16.4477 23 17 23H23V17Z" fill="#C72037"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M24 16C23.4477 16 23 16.4477 23 17V23H17C16.4477 23 16 23.4477 16 24C16 24.5523 16.4477 25 17 25H23V31C23 31.5523 23.4477 32 24 32C24.5523 32 25 31.5523 25 31V25H31C31.5523 25 32 24.5523 32 24C32 23.4477 31.5523 23 31 23H25V17C25 16.4477 24.5523 16 24 16Z" fill="#FDFDFD"/>
      </svg>
    </SvgIcon>
  );
}

export default MenuCreate;